// extracted by mini-css-extract-plugin
export default {"vehicleTag":"styles_vehicleTag__kcMUw"};